import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // Base URL for API

// Function to create an Axios instance
const createApiClient = () => {
  const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  return apiClient;
};

// Main API client with interceptors for token refresh
const apiClient = createApiClient();

export default apiClient;
